module.exports = __webpack_public_path__ + "img/noPrize-share.fd30107f.png";